export default __webpack_public_path__ + "static/media/logo_keiron.cba85864.png";